import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import sh from "bundles/common/utils/sh";
import RecruiterHero from "./landing_page/RecruiterHero";
import HowItWorks from "./landing_page/HowItWorks";
import KanbanShowcase from "./landing_page/KanbanShowcase";
import RecruitmentProcess from "./landing_page/RecruitmentProcess";
import TalentShowcase from "./landing_page/TalentShowcase";
import CompanyPage from "./landing_page/CompanyPage";
import TrustedCompaniesSection from "./landing_page/TrustedCompaniesSection";
import PricingSection from "./landing_page/PricingSection";
import BrochureSection from "./landing_page/BrochureSection";
import RecruiterTestimonial from "./landing_page/RecruiterTestimonial";
import ContactSection from "./landing_page/ContactSection";
import BlogSection from "bundles/common/components/BlogSection";
import CostCalculator from "./landing_page/CostCalculator";

const LandingPageRecruiter = () => {
  const authenticityToken = useSelector((state) => state.authenticity_token);
  // eslint-disable-next-line no-undef
  const trustedCompanyIds = JSON.parse(process.env.TRUSTED_COMPANY_IDS || "[]");

  const [candidatesCount, setCandidatesCount] = useState(0);
  const [jobApplicationsCount, setJobApplicationsCount] = useState(0);
  const [spontaneousApplicationsYearCount, setSpontaneousApplicationsYearCount] = useState(0);
  const [companiesCount, setCompaniesCount] = useState(0);
  const [trustedCompanies, setTrustedCompanies] = useState([]);

  const fetchRecruiterData = () => {
    sh.get("landing_recruiter_data", { authenticity_token: authenticityToken })
      .then((res) => {
        setCandidatesCount(res.data.candidates_count);
        setJobApplicationsCount(res.data.job_applications_count);
        setSpontaneousApplicationsYearCount(res.data.spontaneous_applications_year_count);
        setCompaniesCount(res.data.companies_count);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const fetchTrustedCompanies = () => {
    sh.get("search/companies", {
      params: {
        authenticity_token: authenticityToken,
        filters: { id: trustedCompanyIds },
      },
    })
      .then((res) => {
        const companies = res.data.data.companies.slice(0, 4);
        setTrustedCompanies(companies);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    fetchRecruiterData();
    fetchTrustedCompanies();
  }, []);

  return (
    <>
      <RecruiterHero
        candidatesCount={candidatesCount}
        jobApplicationsCount={jobApplicationsCount}
        companiesCount={companiesCount}
      />
      <HowItWorks />
      <KanbanShowcase />
      <RecruitmentProcess />
      <TalentShowcase candidatesCount={candidatesCount} />
      <TrustedCompaniesSection
        trustedCompanies={trustedCompanies}
        companiesCount={companiesCount}
      />
      <CompanyPage
        spontaneousApplicationsYearCount={spontaneousApplicationsYearCount}
        companiesCount={companiesCount}
      />
      <PricingSection />
      <CostCalculator />
      <BrochureSection />
      <RecruiterTestimonial />
      <BlogSection type="recruiter" />
      <ContactSection />
    </>
  );
};

export default LandingPageRecruiter;
